// src/hooks/useBrouillonFnct.ts — SCE Issues
// Le brouillon d'une FNC-T (« Garder en brouillon », 14/10), pour l'annoncer là
// où l'on rouvre la fenêtre : la ligne FNC-T de la fiche problème, le bouton de
// la fiche équipement (22/10). La copie locale tout de suite, SharePoint ensuite
// (le plus récent des deux) ; sans adresse (bascule de rôle), la copie locale seule.
// `version` : à changer après la fermeture de la fenêtre, pour relire.

import { useEffect, useState } from 'react'
import { chargerBrouillonFnct } from '@/api/brouillonsFnct.api'
import { lireBrouillonLocal, type BrouillonFnct } from '@/utils/brouillonFnct'

export function useBrouillonFnct(cle: string, upn: string, version = 0): BrouillonFnct | null {
  const [brouillon, setBrouillon] = useState<BrouillonFnct | null>(() => (cle ? lireBrouillonLocal(cle) : null))
  useEffect(() => {
    if (!cle) {
      setBrouillon(null)
      return
    }
    setBrouillon(lireBrouillonLocal(cle))
    if (!upn) return
    let annule = false
    void chargerBrouillonFnct(upn, cle).then((b) => {
      if (!annule) setBrouillon(b)
    })
    return () => {
      annule = true
    }
  }, [cle, upn, version])
  return brouillon
}
